import { Icon, IconProps } from '@chakra-ui/react'

export default function FileTreeIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#000'}
      {...props}
    >
      <path
        d="M5.33333 12.5H3.33333C2.59695 12.5 2 11.903 2 11.1667V2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33333 5.16536H2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0565 2.5H8.33331C7.78103 2.5 7.33331 2.94772 7.33331 3.5V6.83333C7.33331 7.38562 7.78103 7.83333 8.33331 7.83333H13C13.5523 7.83333 14 7.38562 14 6.83333V4.44349C14 4.17827 13.8946 3.92392 13.7071 3.73638L12.7636 2.79289C12.5761 2.60536 12.3217 2.5 12.0565 2.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0565 9.83203H8.33331C7.78103 9.83203 7.33331 10.2797 7.33331 10.832V14.1654C7.33331 14.7176 7.78103 15.1654 8.33331 15.1654H13C13.5523 15.1654 14 14.7176 14 14.1654V11.7755C14 11.5103 13.8946 11.2559 13.7071 11.0684L12.7636 10.1249C12.5761 9.93739 12.3217 9.83203 12.0565 9.83203Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
